// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/fieldTicketSettings.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-10188: ONE close-out Field Ticket Settings rule, client + server.)
//
// Side-effect module: attaches `window.FieldTicketSettings`. app.js imports it;
// clock.js (loadFieldTicketItems) and dispatch.js (resolveJobDaySigSettings)
// read it at CALL time.
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  /** The request flags: requested if ANY contributing book requests it. */
  var FTS_REQUEST_FLAGS = ['requireDriverSignature', 'requireCustomerSignature', 'requireStamp', 'requireEmailCopy'];

  /** Approval-link signature modes, weakest first (mirrors ticketApproval.js). */
  var FTS_APPROVAL_MODES = ['off', 'optional', 'required'];

  function _ftsObj(c) {
    var f = c && c.fieldTicketSettings;
    return (f && typeof f === 'object' && !Array.isArray(f)) ? f : null;
  }

  function _ftsId(c) {
    return (c && c.id != null) ? String(c.id) : '';
  }

  /**
   * Strictest-wins merge of several books' fieldTicketSettings.
   * @param {Array<object>} contracts contract docs ({ id, fieldTicketSettings })
   * @returns {object|null} null when no book carries a settings object.
   */
  function combineFieldTicketSettings(contracts) {
    var list = Array.isArray(contracts) ? contracts.filter(function (c) { return !!_ftsObj(c); }) : [];
    if (!list.length) return null;
    // Deterministic order — never Firestore doc order or array order.
    list = list.slice().sort(function (a, b) {
      var x = _ftsId(a), y = _ftsId(b);
      return x < y ? -1 : (x > y ? 1 : 0);
    });
    var out = {};
    for (var i = 0; i < FTS_REQUEST_FLAGS.length; i++) {
      var k = FTS_REQUEST_FLAGS[i];
      out[k] = list.some(function (c) { return _ftsObj(c)[k] === true; });
    }
    // Show costs: hidden if ANY book hides them; otherwise left unset (= shown,
    // every reader tests `!== false`).
    if (list.some(function (c) { return _ftsObj(c).showCostsOnDriverTicket === false; })) {
      out.showCostsOnDriverTicket = false;
    } else if (list.some(function (c) { return _ftsObj(c).showCostsOnDriverTicket === true; })) {
      out.showCostsOnDriverTicket = true;
    }
    // Approval-link signature: only books that set it vote; strictest wins.
    var best = -1;
    for (var j = 0; j < list.length; j++) {
      var raw = String(_ftsObj(list[j]).customerApprovalSignature == null ? '' : _ftsObj(list[j]).customerApprovalSignature).trim().toLowerCase();
      var r = FTS_APPROVAL_MODES.indexOf(raw);
      if (r > best) best = r;
    }
    if (best >= 0) out.customerApprovalSignature = FTS_APPROVAL_MODES[best];
    // Email recipient: only when unambiguous (see the header).
    var hasAddr = function (c) {
      var a = _ftsObj(c).defaultEmailRecipient;
      return typeof a === 'string' && a.trim() !== '';
    };
    var askers = list.filter(function (c) { return _ftsObj(c).requireEmailCopy === true && hasAddr(c); });
    var pool = askers.length ? askers : list.filter(hasAddr);
    var distinct = {};
    var first = null;
    for (var m = 0; m < pool.length; m++) {
      var addr = _ftsObj(pool[m]).defaultEmailRecipient;
      var key = addr.trim().toLowerCase();
      if (!(key in distinct)) { distinct[key] = true; if (first === null) first = addr; }
    }
    if (first !== null && Object.keys(distinct).length === 1) out.defaultEmailRecipient = first;
    return out;
  }

  /**
   * The settings for one close-out.
   * @param {Array<object>} activeContracts the customer's ACTIVE books ({ id, fieldTicketSettings, ... })
   * @param {string|null} jobContractId the book chosen on the job (jobDay.selectedContractId), if any
   * @returns {{ settings: object|null, contractId: string|null, source: 'job'|'combined'|'none' }}
   *   contractId is the book the settings came from when exactly one did, else null.
   */
  function resolveFieldTicketSettings(activeContracts, jobContractId) {
    var list = Array.isArray(activeContracts) ? activeContracts.filter(function (c) { return c && typeof c === 'object'; }) : [];
    if (!list.length) return { settings: null, contractId: null, source: 'none' };
    var want = jobContractId == null ? '' : String(jobContractId);
    if (want) {
      for (var i = 0; i < list.length; i++) {
        if (_ftsId(list[i]) === want) {
          var f = _ftsObj(list[i]);
          var copy = null;
          if (f) { copy = {}; for (var k in f) { if (Object.prototype.hasOwnProperty.call(f, k)) copy[k] = f[k]; } }
          return { settings: copy, contractId: want, source: 'job' };
        }
      }
    }
    var settings = combineFieldTicketSettings(list);
    return {
      settings: settings,
      contractId: list.length === 1 ? (_ftsId(list[0]) || null) : null,
      source: settings ? 'combined' : 'none',
    };
  }

  /**
   * TASK-10190 — WHICH Active book the close-out's "Show on field ticket" ITEMS
   * (and the `contractId` stamped on each FIELD_ITEM line, the book the server
   * prices it from — priceBookLineFlags._txFindPriceBookItem tries the line's
   * contractId first) come from.
   *   - The job day names a book and it is one of these Active books -> that one.
   *   - Otherwise -> the FIRST book in the given order (callers pass Firestore
   *     query order, i.e. what clock-out has always used). No new pricing rule:
   *     with no pick nothing changes, and a picked book that is no longer Active
   *     is never used (it is not in the list).
   * @param {Array<object>} activeContracts the customer's ACTIVE books, in query order
   * @param {string|null} jobContractId jobDay.selectedContractId, if any
   * @returns {{ index: number, contractId: string|null, source: 'job'|'first'|'none' }}
   */
  function pickLineItemsContract(activeContracts, jobContractId) {
    var list = Array.isArray(activeContracts) ? activeContracts : [];
    var want = jobContractId == null ? '' : String(jobContractId);
    if (want) {
      for (var i = 0; i < list.length; i++) {
        if (list[i] && typeof list[i] === 'object' && _ftsId(list[i]) === want) return { index: i, contractId: want, source: 'job' };
      }
    }
    for (var j = 0; j < list.length; j++) {
      if (list[j] && typeof list[j] === 'object') return { index: j, contractId: _ftsId(list[j]) || null, source: 'first' };
    }
    return { index: -1, contractId: null, source: 'none' };
  }

  /**
   * TASK-10190 — the render hint the PIN-driver Build Ticket reads off a job day
   * (jobDay.fieldTicketSettings): the four request flags + the prefilled email
   * address. Same five keys dispatch.js resolveJobDaySigSettings has always
   * stamped. null in -> null out.
   */
  function toJobDayStamp(settings) {
    if (!settings || typeof settings !== 'object') return null;
    var addr = settings.defaultEmailRecipient;
    return {
      requireDriverSignature: settings.requireDriverSignature === true,
      requireCustomerSignature: settings.requireCustomerSignature === true,
      requireStamp: settings.requireStamp === true,
      requireEmailCopy: settings.requireEmailCopy === true,
      defaultEmailRecipient: (typeof addr === 'string' && addr.trim()) ? addr : null,
    };
  }

  window.FieldTicketSettings = Object.freeze({
    FTS_REQUEST_FLAGS: Object.freeze(FTS_REQUEST_FLAGS.slice()),
    combineFieldTicketSettings: combineFieldTicketSettings,
    resolveFieldTicketSettings: resolveFieldTicketSettings,
    pickLineItemsContract: pickLineItemsContract,
    toJobDayStamp: toJobDayStamp
  });
})();
